"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedcar = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 60 39",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedcar` : '') + (description ? ` desc-brandedcar` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedcar"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedcar"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M60 28.1s-.37-9.85-4.68-18.8l-2.49-5.57c-.3-.69.52-1.52-.29-2.54-.6-.4-1-.41-1.7-.4L40.57.72c-1.07 1.19-1 3.93-2.12 5.08l.95 1.25-2.18 7.87-7.52-.03S12.91 29.51 1.1 31.93c.34-.18.9 1.16 1.55 1.16l53.64-.07c2.05 0 3.7-1.12 3.7-3.32l.02-1.6Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.4 14.88a1.36 1.36 0 0 1-1.01-2.27l7.56-8.89 11.77-.02S43.3 2 44.4.73c-5.98-.03-14.11 0-17.05 0-.36 0-.7.16-.95.41-1.68 1.69-10.96 10.82-11.6 11.16-.3.12-8.1 1.83-12.18 3.1a3.07 3.07 0 0 0-1.85 2.82l.01 7.82c-.28.17-.52.42-.67.71-.16.3-.03.74-.03 1.09l.02 2.42c0 .4.39.4.47 1.04.1-.04.9.13.99.08 11.46-1.73 24.24-12.96 28.5-16.5H23.4Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M.75 26.06c.28-.18.6-.27.92-.27H9.1v-3.55c0-.53-.2-1.03-.55-1.4a1.78 1.78 0 0 0-1.31-.6H.74v5.82Z",
    fill: "#FDF1F3"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.75 20.25v5.81h3.71v-3.81a1.99 1.99 0 0 0-1.15-1.84c-.21-.1-.46-.16-.7-.16H5.75Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.33 30.93c0-1.85 1.09-1.4.9-2.49 1.21-1.3 4-3.94 5.72-3.94H1.85c-.98 0-1.85.87-1.85 2v4.67a1.9 1.9 0 0 0 1.86 2h6.69c-.06-.34-.22-2.24-.22-2.24Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M35.6 19.03a.78.78 0 0 0-.77-.78h-4.4a.77.77 0 0 0-.77.78v.44c0 .42.34.78.77.78h4.4c.42 0 .76-.35.76-.78v-.44Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M55.85 24.25v-2.98c0-.11.02-.23.06-.34a1 1 0 0 1 .94-.68h2.08s.43 1.83.58 3.08l.11.92",
    fill: "#FDF1F3"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M60 28.24h-3.08c-.13 0-.25-.02-.36-.06a1 1 0 0 1-.65-.93v-3h3.71s.34 2.62.38 4Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M52.4 12.78 49.53 4.4c-.12-.2-.28-.37-.48-.5a1.3 1.3 0 0 0-.64-.17h-3.8l-4.13 11.19h10.8a1.33 1.33 0 0 0 1.15-.72c.11-.22.17-.47.17-.71 0-.25-.07-.5-.2-.7Z",
    fill: "#8AE6EB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M30.04 14.88h7.19l4.5-11.18",
    fill: "#8AE6EB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m28.9 4.2-7.33 8.44a1.36 1.36 0 0 0 1 2.28l7.47-.03A150.9 150.9 0 0 0 41.72 3.7l-11.77.03c-.4 0-.8.17-1.07.48h.01Z",
    fill: "#DAFCFE"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M48 38.71c1.86 0 3.64-.75 4.95-2.09a7.2 7.2 0 0 0 0-10.08 6.93 6.93 0 0 0-9.9 0 7.2 7.2 0 0 0 0 10.08 6.93 6.93 0 0 0 4.95 2.1Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M48 34.64a2.95 2.95 0 0 0 2.12-.9 3.06 3.06 0 0 0 .65-3.33 3.06 3.06 0 0 0-1.62-1.66 2.95 2.95 0 0 0-3.27.67 3.09 3.09 0 0 0 0 4.32c.56.57 1.32.9 2.12.9Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15 38.71c1.86 0 3.64-.75 4.95-2.09a7.2 7.2 0 0 0 0-10.08 6.93 6.93 0 0 0-9.9 0 7.2 7.2 0 0 0 0 10.08 6.93 6.93 0 0 0 4.95 2.1Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15 34.64a2.95 2.95 0 0 0 2.12-.9 3.06 3.06 0 0 0 .65-3.33 3.06 3.06 0 0 0-1.62-1.66 2.95 2.95 0 0 0-3.27.67 3.09 3.09 0 0 0 0 4.32c.56.57 1.32.9 2.12.9Z",
    fill: "white"
  }));
};
var _default = exports.default = brandedcar;